/* Cart upsell slider + product page upsell - Dawn
 *
 * Fetches sections/cart-upsell.liquid via the Section Rendering API and
 * injects it above the cart drawer footer and the cart page footer.
 * The [data-upsell-add] click handler also serves the product page rows
 * rendered by snippets/product-upsell.liquid.
 *
 * WHY NOT THE SECTION RENDERING API FOR THE DRAWER:
 * this theme's cart drawer lives in snippets/cart-drawer.liquid, not a
 * section, so ?sections=cart-drawer returns nothing usable and the item list
 * came back blank. Instead we re-fetch the current page (server-rendered with
 * the updated cart) and swap the <cart-drawer> contents in place. No reload,
 * drawer stays open. If that fails for any reason we fall back to a reload.
 *
 * BINDING: this file loads from <head> and runs before pubsub.js, so init()
 * retries. Click handlers bind exactly once behind the `bound` flag - binding
 * inside the retry loop attaches a listener per retry and double-adds.
 */
(function () {
  'use strict';

  if (window.__cartUpsellLoaded) return;
  window.__cartUpsellLoaded = true;

  var HOSTS = ['.cart-drawer__footer', '.drawer__footer', '.cart__footer'];
  var REOPEN_KEY = 'cartUpsellReopenDrawer';

  var bound = false;
  var adding = false;

  function root() {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
  }

  function addUrl() {
    return (window.routes && window.routes.cart_add_url) || root().replace(/\/$/, '') + '/cart/add';
  }

  function fetchSection() {
    return fetch(root() + '?section_id=cart-upsell')
      .then(function (r) { return r.text(); })
      .catch(function () { return ''; });
  }

  function clearExisting() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-upsell]'), function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
  }

  function mount(html) {
    clearExisting();
    if (!html || html.indexOf('data-cart-upsell') === -1) return;

    var host = null;
    for (var i = 0; i < HOSTS.length; i++) {
      var found = document.querySelector(HOSTS[i]);
      if (found) { host = found; break; }
    }
    if (!host || !host.parentNode) return;

    var wrapper = document.createElement('div');
    wrapper.innerHTML = html.trim();
    var upsell = wrapper.querySelector('[data-cart-upsell]');
    if (!upsell) return;

    host.parentNode.insertBefore(upsell, host);
  }

  function refresh() {
    fetchSection().then(mount);
  }

  function releaseButton(button) {
    adding = false;
    if (!button) return;
    button.disabled = false;
    button.classList.remove('is-loading');
  }

  function flagReopen() {
    try {
      window.sessionStorage.setItem(REOPEN_KEY, '1');
    } catch (e) { /* private mode - drawer just stays closed */ }
  }

  function hardReload() {
    flagReopen();
    window.location.reload();
  }

  function openDrawer(attempt) {
    attempt = attempt || 0;
    var drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.open === 'function') {
      try {
        drawer.open();
        return;
      } catch (e) {
        console.warn('[cart-upsell] drawer.open() threw:', e);
      }
    }

    if (attempt < 40) {
      setTimeout(function () { openDrawer(attempt + 1); }, 100);
      return;
    }

    var cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink) {
      console.warn('[cart-upsell] cart-drawer never upgraded, clicking cart icon instead');
      cartLink.click();
    }
  }

  function reopenIfFlagged() {
    var flagged = false;
    try {
      flagged = window.sessionStorage.getItem(REOPEN_KEY) === '1';
      if (flagged) window.sessionStorage.removeItem(REOPEN_KEY);
    } catch (e) {
      return;
    }
    if (flagged) openDrawer(0);
  }

  /* Swap the live drawer's contents with a freshly rendered copy of itself. */
  function syncDrawer(wasOpen, button) {
    var url = window.location.pathname + window.location.search;

    fetch(url, { cache: 'no-store', headers: { 'X-Requested-With': 'cart-upsell' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        var live = document.querySelector('cart-drawer');

        if (!fresh || !live) {
          hardReload();
          return;
        }

        live.innerHTML = fresh.innerHTML;
        live.classList.toggle('is-empty', fresh.classList.contains('is-empty'));

        // The overlay node was just replaced, so its close listener died with
        // it. Dawn binds this in the CartDrawer constructor, which won't run
        // again - rebind by hand or the drawer can't be dismissed.
        var overlay = live.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof live.close === 'function') {
          overlay.addEventListener('click', live.close.bind(live));
        }

        var freshBubble = doc.querySelector('#cart-icon-bubble');
        var liveBubble = document.querySelector('#cart-icon-bubble');
        if (freshBubble && liveBubble) liveBubble.innerHTML = freshBubble.innerHTML;

        if (!wasOpen) openDrawer(0);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell' });
        }

        refresh();
        releaseButton(button);
      })
      .catch(function (e) {
        console.warn('[cart-upsell] drawer sync failed, reloading:', e);
        hardReload();
      });
  }

  function addToCart(variantId, button) {
    if (adding || !variantId) return;
    if (button && button.disabled) return;

    adding = true;
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }

    var drawer = document.querySelector('cart-drawer');
    var wasOpen = !!(drawer && drawer.classList.contains('active'));

    fetch(addUrl() + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          console.warn('[cart-upsell] add rejected:', response.description || response.message);
          releaseButton(button);
          return;
        }

        if (!drawer) {
          window.location.reload();
          return;
        }

        syncDrawer(wasOpen, button);
      })
      .catch(function (e) {
        console.warn('[cart-upsell] add failed:', e);
        releaseButton(button);
      });
  }

  function onDocumentClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var addButton = target.closest('[data-upsell-add]');
    if (addButton) {
      event.preventDefault();
      event.stopPropagation();
      addToCart(addButton.getAttribute('data-variant-id'), addButton);
      return;
    }

    if (target.closest('#cart-icon-bubble, cart-drawer, .cart-drawer')) {
      setTimeout(refresh, 250);
    }
  }

  function bindHandlers() {
    if (bound) return;
    bound = true;
    document.addEventListener('click', onDocumentClick);
  }

  function start() {
    bindHandlers();
    reopenIfFlagged();
    refresh();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
        if (data && data.source === 'cart-upsell') return;
        setTimeout(refresh, 300);
      });
    }
  }

  function init(attempt) {
    attempt = attempt || 0;

    if ((typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') && attempt < 40) {
      setTimeout(function () { init(attempt + 1); }, 50);
      return;
    }

    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(0); });
  } else {
    init(0);
  }
})();
